import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { RejectTable } from "./RejectTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./rejectSlice";

export const RejectPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter

  const [invoiceNo, setInvoiceNo] = useState("");
  const [retNumber, setRetNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [materialCode, setMaterialCode] = useState("");

  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);

    if (data !== null && data !== undefined && data.length > 0) {
      const initData = data.map((item, index) => {
        return {
          ...item,
          no: index + 1 + pageBefore,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      retNumber: retNumber,
      invoiceNo: invoiceNo,
      customerName: customerName,
      materialName: materialName,
      materialCode: materialCode,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    console.log("params", params);
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      retNumber: retNumber,
      invoiceNo: invoiceNo,
      customerName: customerName,
      materialName: materialName,
      materialCode: materialCode,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Reject Return"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form as={Row}>
          {/* Left Row */}
          <Col sm={6}>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>APL Return Number </b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="number"
                  placeholder="APL Return Number "
                  onChange={(e) => {
                    setRetNumber(e.target.value);
                  }}
                  value={retNumber}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Invoice Ref Number</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="number"
                  placeholder="Invoice Ref Number"
                  onChange={(e) => {
                    setInvoiceNo(e.target.value);
                  }}
                  value={invoiceNo}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Customer Name</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Customer Name"
                  onChange={(e) => {
                    setCustomerName(e.target.value);
                  }}
                  value={customerName}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Right Row */}
          <Col sm={6}>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Material Desc</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Material Desc"
                  onChange={(e) => {
                    setMaterialName(e.target.value);
                  }}
                  value={materialName}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                <b>Material Code</b>
              </Form.Label>
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Material Code"
                  onChange={(e) => {
                    setMaterialCode(e.target.value);
                  }}
                  value={materialCode}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Button */}
          <Form.Group as={Row} className="ml-1">
            <Col sm={6}>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <RejectTable
            data={tableData}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
